/* eslint-disable */
import * as React from "react";

import { createStyles } from "@material-ui/styles";
import { Theme, makeStyles } from "@material-ui/core";

import { ReportToolbarGroup } from "../../../components/ReportToolbar";
import { CommoditiesControl } from "../controls/CommoditiesControl";
import { useFavourite } from "./useFavourite";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexDirection: "column",
      gap: theme.spacing(2),
      "& >*": {
        marginLeft: 0,
      },
    },
  })
);

export default function () {
  const classes = useStyles();

  useFavourite();
  return (
    <ReportToolbarGroup className={classes.root}>
      <CommoditiesControl />
    </ReportToolbarGroup>
  );
}
